<template>
  <div class="sidebar-wrapper no-print" id="Sidbar">
    <nav :class="{ sidebar: true, sidebarStatic, sidebarOpened }" @mouseenter="sidebarMouseEnter" @mouseleave="sidebarMouseLeave">
      <header class="logo">
        <router-link to="/app/dashboard"><span class="primary-word">CRM</span> <span class="secondary-word"> App</span> </router-link>
      </header>

      <!-- <a v-if="$session.get('CustomerInfo').CustomerName!=''" class="generator-link navTitle" target="_self" href="javascript:;"> {{$session.get('CustomerInfo').CustomerName}}</a> -->
      <a class="generator-link navTitle" target="_self" href="javascript:;"> {{ $session.get('CompanyName') }}</a>

      <!-- <h5 class="navTitle first">منوی اصلی</h5> -->
      <ul>
        <NavLink :activeItem="activeItem" header="پیشخوان" link="/app/dashboard" iconName="fas fa-home" index="dashboard" isHeader />
      </ul>

      <ul v-for="item in ChildMenu" :key="item.id" class="nav">
        <NavLink :activeItem="activeItem" :header="item.label" :link="item.ControlName" :iconName="item.MenuIcon" :index="item.ControlName" :childrenLinks="Getchild(item.Children)" :isParent="0" :menuId="item.id" />

        <!-- <NavLink
            :activeItem="activeItem"
            header="هشدارها"
            link="/app/tables"
            iconName="flaticon-equal-1"
            index="tables"
            isHeader
        />
        <NavLink
            :activeItem="activeItem"
            header="قرارداد ها"
            link="/app/notifications"
            iconName="flaticon-bell"
            index="notifications"
            isHeader
        /> -->
      </ul>
      <!-- <h5 class="navTitle">
        سایر امکانات
      </h5>
      <ul class="sidebarLabels">
        <li>
          <a href="#">
            <span class="labelName mr-2">هشدار</span>
                        <i class="fa fa-circle text-danger"/>

          </a>
        </li>
        <li>
          <a href="#">
            <span class="labelName mr-2">تماس</span>
                        <i class="fa fa-circle text-primary"/>

          </a>
        </li>
        <li>
          <a href="#">
            <span class="labelName mr-2">اندیکاتور</span>
                        <i class="fa fa-circle text-success"/>

          </a>
        </li>

      </ul> -->
      <!-- <h5 class="navTitle">
        پروژه ها
      </h5>
      <div class="sidebarAlerts">
        <b-alert
            v-for="alert in alerts"
            :key="alert.id"
            class="sidebarAlert" variant="transparent"
            show dismissible
        >
          <span>{{alert.title}}</span><br/>
          <b-progress class="sidebarProgress progress-xs mt-1"
                      :variant="alert.color" :value="alert.value" :max="100"/>
          <small>{{alert.footer}}</small>
        </b-alert>
      </div> -->
    </nav>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import isScreen from '@/core/screenHelper'
import NavLink from './NavLink/NavLink'

export default {
  name: 'Sidebar',
  components: { NavLink },
  data() {
    return {
      alerts: [
        {
          id: 0,
          title: 'فروش ماه جاری',
          value: 15,
          footer: 'مجموع پیشترفت ... 65 %',
          color: 'danger',
        },
        {
          id: 1,
          title: 'تیکت های پاسخ داده شده',
          value: 20,
          footer: 'Provide required notes',
          color: 'primary',
        },
        {
          id: 2,
          title: 'تیکت های بازه',
          value: 40,
          footer: 'Provide required notes',
          color: 'warning',
        },
      ],
      ChildMenu: [],
    }
  },
  methods: {
    Getchild(arr) {
      var a = []
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].IsMenu && arr[i].RouteName != '-') {
          a.push({ header: arr[i].label, link: arr[i].RouteName, children: arr[i].Children, id: arr[i].id })
        }
      }
      return a
    },

    ...mapActions('layout', ['changeSidebarActive', 'switchSidebar']),
    setActiveByRoute() {
      const paths = this.$route.fullPath.split('/')
      paths.pop()
      this.changeSidebarActive(paths.join('/'))
    },
    sidebarMouseEnter() {
      if (!this.sidebarStatic && (isScreen('lg') || isScreen('xl'))) {
        this.switchSidebar(false)
        this.setActiveByRoute()
      }
    },
    sidebarMouseLeave() {
      if (!this.sidebarStatic && (isScreen('lg') || isScreen('xl'))) {
        this.switchSidebar(true)
        this.changeSidebarActive(null)
      }
    },
  },
  created() {
    this.AllMenu = this.$session.get('Menu')
    // console.log(this.AllMenu)
    this.setActiveByRoute()
  },
  beforeMount() {
    var Parents = []

    for (var i = 0; i < this.AllMenu.length; i++) {
      if (this.AllMenu[i].ParentId == null && this.AllMenu[i].IndexMenu != '00                  ' && this.AllMenu[i].isMojaz == true) {
        Parents.push(this.AllMenu[i])
      }
    }

    for (let index = 0; index < Parents.length; index++) {
      for (var i = 0; i < this.AllMenu.length; i++) {
        if (this.AllMenu[i].ParentId == Parents[index].id) {
          for (let j = 0; j < this.AllMenu.length; j++) {
            const element = this.AllMenu[j]
            if (element.ParentId == this.AllMenu[i].id && element.isMojaz == 1) {
              if (this.AllMenu[i].Children) {
                this.AllMenu[i].Children.push(element)
              } else {
                this.AllMenu[i].Children = [element]
              }
            }
          }
          if (this.AllMenu[i].Children != undefined) {
            for (let k = 0; k < this.AllMenu[i].Children.length; k++) {
              if (Parents[index].Children) {
                Parents[index].Children.push(this.AllMenu[i].Children[k])
              } else {
                Parents[index].Children = [this.AllMenu[i].Children[k]]
              }
            }
          }
        }
      }
    }

    Parents.forEach((element) => {
      element.Children.forEach((element2) => {
        element2.Children = []
        this.AllMenu.forEach((element3) => {
          if (element2.id == element3.ParentId) {
            this.AllMenu.forEach((element4) => {
              if (element3.id == element4.ParentId) element2.Children.push(element4)
              element2.showCollapse = false
            })
          }
        })
      })
    })

    /////////////////////////////////////////////////////////////////////////////////////

    // Parents.forEach((el)=>{
    //   this.AllMenu.forEach((el2)=>{
    //     if(el2.ParentId == el.id){
    //       this.AllMenu.forEach((el3)=>{
    //         if(el3.ParentId == el2.id){
    //           el3.ParentId = el.id
    //         }
    //       })
    //     }
    //   })
    // })

    // this.AllMenu.forEach((el)=>{
    //   var childs = []
    //   this.AllMenu.forEach((el2)=>{
    //     if(el.id == el2.ParentId){
    //       childs.push(el2)
    //     }
    //   })
    //   el.Children = []
    //   el.Children = childs
    // })

    // Parents.forEach((el)=>{
    //   el.Children = []
    //   this.AllMenu.forEach((el2)=>{
    //     if(el.id == el2.ParentId){
    //       el.Children.push(el2)
    //     }
    //   })
    // })

    // console.log("!!", this.AllMenu);
    // console.log("!^", Parents);

    // let find= this.AllMenu.find(x=> x.id == 72)
    // console.log("*", find);

    // for (var i = 0; i < this.AllMenu.length; i++) {
    //   this.AllMenu[i].Children = []
    //   for (var j = 0; j < this.AllMenu.length; j++) {
    //     // خواندن فرزندان هر سطح از منو
    //     if (this.AllMenu[i].id == this.AllMenu[j].ParentId && this.AllMenu[j].isMojaz == true) {
    //       this.AllMenu[i].Children.push(this.AllMenu[j])
    //     }
    //   }
    // }

    // for (var i = 0; i < this.AllMenu.length; i++) {
    //   this.AllMenu[i].Children = []
    //   for (var j = 0; j < this.AllMenu.length; j++) {
    //     // خواندن فرزندان هر سطح از منو
    //     if (this.AllMenu[i].id == this.AllMenu[j].ParentId && this.AllMenu[j].isMojaz == true) {
    //       this.AllMenu[i].Children.push(this.AllMenu[j])
    //     }
    //   }
    // }

    // var childs2 = []
    // n = 0
    // for (var i = 0; i < this.AllMenu.length; i++) {
    //   if (this.AllMenu[i].ParentId == null && this.AllMenu[i].IndexMenu != "00                  ") {
    //     for (var j = 0; j < this.AllMenu[i].Children.length; j++) {
    //       for (var k = 0; k < this.AllMenu[i].Children[j].Children.length; k++) {
    //         childs2[n] = this.AllMenu[i].Children[j].Children[k]
    //         childs2[n].ParentId = this.AllMenu[i].IdGrpMenu
    //         n++
    //       }
    //     }
    //   }
    // }

    // console.log("childs2", childs2);

    // for (var i = 0; i < Parents.length; i++) {
    //   var childs = []
    //   var n = 0
    //   for (var j = 0; j < childs2.length; j++) {

    //     if (Parents[i].id == childs2[j].ParentId && this.AllMenu[i].isMojaz == true) {
    //       childs[n] = childs2[j]
    //       n++
    //     }
    //   }
    //   Parents[i].Children = childs
    // }

    this.ChildMenu = Parents
  },
  computed: {
    ...mapState('layout', {
      sidebarStatic: (state) => state.sidebarStatic,
      sidebarOpened: (state) => !state.sidebarClose,
      activeItem: (state) => state.sidebarActiveElement,
    }),
  },
}
</script>

<!-- Sidebar styles should be scoped -->

<style src="./Sidebar.scss" lang="scss" scoped />
